import { render, staticRenderFns } from "./drafts.vue?vue&type=template&id=99b678f0&scoped=true&"
import script from "./drafts.vue?vue&type=script&lang=js&"
export * from "./drafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b678f0",
  null
  
)

export default component.exports